<template>
	<el-cascader
	  :placeholder="placeholder"
	  ref="EAadr"
	  v-model="cascader"
	  :props="props"
	  :size="$store.state.isphone?'mini':''"
	  @visible-change="addlatlng($refs.EAadr)"
	  style="width: 100%;">
	</el-cascader>
</template>

<script>
	export default {
		data() {
			return {
				props: {
					checkStrictly: true,
					value: 'id',
					label: 'name',
					children: 'children',
					lazy: true,
					lazyLoad: (node, resolve) => {
						let val=node.path;
						if(val==null)
						{
							val=[];
						}
						this.loadadr(val)
						.then((adr) => {
							resolve(adr);
						});
					}
				}
			}
		},
		methods:{
			
		},
		props: {
			value: {
				type: [String,Number],
				default: ''
			},
			placeholder: {
				type: String,
				default: ''
			},
			addlatlng: {
				type: Function,
				default: function(){
					
				}
			}
		},
		mounted: function () {
			
		},
		computed:{
			cascader: {
				get () {
					return this.value.toString().split(',');
				},
				set (value) {
					var o=document.createElement('input');
					o.input=()=>{
						this.$emit('input', this.adrtrans(value));
					}
					o.input();
				}
			}
		}
	}
</script>

<style>
</style>
